import Vue from 'vue'
import VueRouter from 'vue-router'
import { isLoggedIn } from '@/utils/auth'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    meta: { public: true, title: '登录' },
    component: () => import('../views/LoginView.vue')
  },
  {
    path: '/',
    redirect: '/sessions'
  },
  {
    path: '/consult-pool',
    name: 'consultPool',
    meta: {
      title: '咨询池',
      desc: '抢接新咨询，进入我的会话后继续跟进'
    },
    component: () => import('../views/ConsultPoolView.vue')
  },
  {
    path: '/sessions',
    name: 'sessions',
    meta: {
      title: '我的会话',
      desc: '已抢单客户会话，在聊天中推进报价、下单和交付'
    },
    component: () => import('../views/SessionsView.vue')
  },
  {
    path: '/order-pool',
    name: 'orderPool',
    meta: {
      title: '订单池',
      desc: '查看订单进度，沟通咨询并跟进办件'
    },
    component: () => import('../views/OrderPoolView.vue')
  },
  {
    path: '/quote/generate',
    name: 'quoteGenerate',
    meta: {
      title: '生成报价',
      fullscreen: true
    },
    component: () => import('../views/QuoteGenerateView.vue')
  },
  {
    path: '/dispatch',
    name: 'dispatch',
    meta: {
      title: '派单管理',
      desc: '分配外勤任务并跟踪派单进度'
    },
    component: () => import('../views/DispatchView.vue')
  },
  {
    path: '/field',
    name: 'field',
    meta: {
      title: '外勤管理',
      desc: '查看外勤人员与现场作业情况'
    },
    component: () => import('../views/FieldView.vue')
  },
  {
    path: '/settings/address',
    name: 'addressManage',
    meta: {
      title: '收件地址管理',
      desc: '维护客服发送给客户的资料收件地址'
    },
    component: () => import('../views/AddressView.vue')
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const loggedIn = isLoggedIn()

  if (to.meta.public) {
    if (loggedIn && to.path === '/login') {
      next('/sessions')
    } else {
      next()
    }
    return
  }

  if (!loggedIn) {
    next({ path: '/login', query: { redirect: to.fullPath } })
    return
  }

  next()
})

export default router
